import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Calls from './pages/Calls';
import Numbers from './pages/Numbers';
import Analytics from './pages/Analytics';
import Dialer from './pages/Dialer';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  // Render nothing until /me answers, so the dashboard does not flash before
  // the redirect.
  if (loading) return null;
  if (!user) {
    window.location.href = '/login';
    return null;
  }
  return <>{children}</>;
};

const AppLayout: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="app">
      <Sidebar />
      <main className="main-content">
        {user && (
          <div className="topbar">
            <button onClick={logout} className="logout-button">
              Sign out ({user.username})
            </button>
          </div>
        )}
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/calls" element={<Calls />} />
          <Route path="/numbers" element={<Numbers />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/dialer" element={<Dialer />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
